import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { storageFactory } from '../storage-factory';
const local = storageFactory(() => localStorage);
const session = storageFactory(() => sessionStorage);
export function useLocalState(defaultValue, key) {
  const $ = _c(9);
  let t0;
  if ($[0] !== defaultValue || $[1] !== key) {
    t0 = () => JSON.parse(local.getItem(key) || "null") ?? defaultValue;
    $[0] = defaultValue;
    $[1] = key;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [state, setState] = React.useState(t0);
  let t1;
  let t2;
  if ($[3] !== key || $[4] !== state) {
    t1 = () => {
      local.setItem(key, JSON.stringify(state));
    };
    t2 = [key, state];
    $[3] = key;
    $[4] = state;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  React.useEffect(t1, t2);
  let t3;
  if ($[7] !== state) {
    t3 = [state, setState];
    $[7] = state;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export function useSessionState(defaultValue, key) {
  const $ = _c(9);
  let t0;
  if ($[0] !== defaultValue || $[1] !== key) {
    t0 = () => JSON.parse(session.getItem(key) || "null") ?? defaultValue;
    $[0] = defaultValue;
    $[1] = key;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [state, setState] = React.useState(t0);
  let t1;
  let t2;
  if ($[3] !== key || $[4] !== state) {
    t1 = () => {
      session.setItem(key, JSON.stringify(state));
    };
    t2 = [key, state];
    $[3] = key;
    $[4] = state;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  React.useEffect(t1, t2);
  let t3;
  if ($[7] !== state) {
    t3 = [state, setState];
    $[7] = state;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}